import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue";
const _hoisted_1 = { class: "layout" };
const _hoisted_2 = { class: "listBox p-lr32 border-box" };
const _hoisted_3 = {
    key: 0,
    class: "noMore"
};
import { ref } from 'vue';
import CourseList from '@/components/list/CourseList.vue';
import Header from '@/components/common/Header.vue';
import BetterScroll from '@/components/common/BetterScroll.vue';
import { getExpertCourse } from '@/api/es';
import { getDepId } from '@/api/user';
import { getUserId, appPort, hiddenAppNavBar } from '@/widget';
import { useRoute } from 'vue-router';
export default /*#__PURE__*/ _defineComponent({
    setup(__props) {
        const route = useRoute();
        const type = String(route.params.type);
        const id = String(route.params.id);
        if (appPort()) {
            hiddenAppNavBar();
        }
        let departmentId = 0;
        const getData = async () => {
            const userId = getUserId();
            await getDepId(userId).then((res) => {
                if (res.code == 200) {
                    departmentId = res.data.depId;
                }
            });
            getList();
        };
        const list = ref([]);
        let page = 1;
        const noMore = ref(false);
        const loaded = ref(false);
        let loading = false;
        const getList = () => {
            if (noMore.value) {
                return;
            }
            if (loading) {
                return;
            }
            if (departmentId) {
                loaded.value = false;
                loading = true;
                getExpertCourse({
                    page,
                    departmentId,
                    expertId: id,
                    navigationType: type.toLocaleUpperCase(),
                    stepType: 'STEP10'
                }).then((res) => {
                    if (res.code == 200) {
                        loaded.value = true;
                        loading = false;
                        if (page == 1) {
                            list.value = res.data.items;
                        }
                        else {
                            list.value = list.value.concat(res.data.items);
                        }
                        if (res.data.pages > page) {
                            noMore.value = false;
                            page++;
                        }
                        else {
                            noMore.value = true;
                        }
                    }
                });
            }
        };
        getData();
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(Header, {
                    pageTitle: '大师课',
                    isColor: false
                }),
                _createVNode(BetterScroll, {
                    options: {
                        scrollY: true,
                        scrollX: false,
                        click: true,
                        mouseWheel: true,
                        scrollbar: {
                            fade: false,
                            interactive: true
                        },
                        pullUpLoad: true
                    },
                    noMore: noMore.value,
                    loaded: loaded.value,
                    onUpLoad: getList,
                    domStyle: {
                        position: 'relative',
                        height: 'calc(100vh - 0.88rem)'
                    },
                    ref: (_value, _refs) => {
                        _refs['listBs'] = _value;
                    }
                }, {
                    default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_2, [
                            _createVNode(CourseList, { list: list.value }, null, 8, ["list"])
                        ]),
                        (noMore.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_3, "没有更多了"))
                            : _createCommentVNode("", true)
                    ]),
                    _: 1
                }, 8, ["noMore", "loaded", "domStyle"])
            ]));
        };
    }
});
